<template>
  <div class="more">
    <a-divider>
      <span style="font-size:14px" @click="click">
        查看更多
        <a-icon type="right" />
      </span>
    </a-divider>
  </div>
</template>
<script>
export default {
  methods: {
    click() {
      this.$emit('click');
    }
  }
};
</script>
<style lang="less" scoped>
.more {
  span {
    color: #1892f7;
    cursor: pointer;
  }
  /deep/.ant-divider {
    margin: 12px 0 4px 0;
  }
}
</style>
